/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as manipulações de orgãos
 * @author Bene Lemuel Dantas Gondim
 * @file orgaosReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

// Estado inicial da sessão no redux
const initialState = {
  orgaos: [],
  error: null,
  nomeFuncao: '',
  dados: {
    id: '',
    nomeOrgao: '',
    sigla: '',
    descricao: '',
  },
  processandoOrgaos: false,
}

const orgaosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ORGAOS: {
      return {
        ...state,
        orgaos: action.orgaos,
      }
    }

    default: {
      return state
    }
  }
}

export default orgaosReducer
